import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73b8fe4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8fe4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b8fe4a')) {
      api.createRecord('73b8fe4a', component.options)
    } else {
      api.reload('73b8fe4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73b8fe4a&scoped=true", function () {
      api.rerender('73b8fe4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/index.vue"
export default component.exports